export const FEATURES_CONSTANTS = {
  title: "Features of Onemind’s Dedicated Servers",
  list: [
    {
      label: "Enterprise-Grade Hardware",
      text: "Powered by Intel Xeon & AMD EPYC processors for high-performance computing.",
    },
    {
      label: "High-Speed NVMe SSD Storage",
      text: "Ultra-fast read/write speeds for AI, ML, and high-transaction applications.",
    },
    {
      label: "Custom Server Configurations",
      text: "Tailor CPU, RAM, disk, and network for your specific workloads.",
    },
    {
      label: "Global Data Centers",
      text: "Low-latency connectivity across North America, Europe, and Asia.",
    },
    {
      label: "99.99% Uptime SLA",
      text: "Redundant infrastructure ensures high availability and business continuity.",
    },
  ],
};
